<div class="d-flex align-items-center justify-content-between mb-3">
  <div class="card-heading">Change Packaging</div>
  <button mat-icon-button (click)="this.dialogRef.close()" type="button">
    <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
  </button>
</div>

<form [formGroup]="form" (ngSubmit)="formSubmit()">
  <ng-container formArrayName="sale_order_rx_packagings">
    <ng-container
      *ngFor="let item of sale_order_rx_packagings_arr.controls; let i = index"
    >
      <ng-container [formGroupName]="i">
        <div class="row py-2" *ngIf="item.value.ShipType == PackagingType.Ship">
          <div class="col-md-12">
            <div class="card-sub-heading">Ship Packaging</div>
            <div class="row py-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Location:</label>
                  <mat-select
                    class="form-control matselect"
                    placeholder="Select the Location"
                    formControlName="StateID"
                    (selectionChange)="
                      onSelectionChange(
                        $event,
                        i,
                        PackagingType.Ship,
                        'StateID'
                      )
                    "
                  >
                    <mat-option
                      *ngFor="let item of location.ship_states"
                      [value]="item.id"
                    >
                      {{ item.state_name }}
                    </mat-option>
                  </mat-select>
                  <app-error-message
                    [type]="'group'"
                    [formName]="getFormName(i)"
                    [fieldName]="'StateID'"
                  >
                  </app-error-message>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Ship Packaging:</label>
                  <mat-select
                    class="form-control mat-select"
                    placeholder="Type"
                    formControlName="InventoryTypeID"
                    (selectionChange)="
                      onSelectionChange(
                        $event,
                        i,
                        PackagingType.Ship,
                        'InventoryTypeID'
                      )
                    "
                  >
                    <mat-option
                      *ngFor="let item of inventryType.ship_inventory_types"
                      [value]="item.id"
                    >
                      {{ item.type }}
                    </mat-option>
                  </mat-select>
                  <app-error-message
                    [type]="'group'"
                    [formName]="getFormName(i)"
                    [fieldName]="'InventoryTypeID'"
                  >
                  </app-error-message>
                </div>
              </div>
              <ng-container>
                <div
                  class="error-message text-danger ml-3"
                  *ngIf="showQtyError"
                >
                  Quantity does not exist, please try another
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="row py-2 border-bottom">
          <div class="col-md-12">
            <div
              class="d-flex align-items-center justify-content-between"
              *ngIf="isMultipleRXPackaging"
            >
              <div class="card-sub-heading">Rx Packaging</div>
              <div>
                <button mat-icon-button>
                  <img
                    src="assets/images/random_assets/add_field.png"
                    alt="add_field icon"
                    (click)="addPackaging(PackagingType.RX)"
                  />
                </button>
              </div>
            </div>
            <ng-container *ngIf="item.value.ShipType == PackagingType.RX">
              <div class="d-flex align-items-center justify-content-between">
                <div class="card-sub-heading" *ngIf="i == 1">Rx Packaging</div>
                <div>
                  <button mat-icon-button *ngIf="i == 1">
                    <img
                      src="assets/images/random_assets/add_field.png"
                      alt="add_field icon"
                      (click)="addPackaging(PackagingType.RX)"
                    />
                  </button>
                </div>
              </div>
              <div class="row py-3">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Location:</label>
                    <mat-select
                      class="form-control matselect"
                      placeholder="Select the Location"
                      formControlName="StateID"
                      (selectionChange)="
                        onSelectionChange(
                          $event,
                          i,
                          PackagingType.RX,
                          'StateID'
                        )
                      "
                    >
                      <mat-option
                        *ngFor="let item of location.rx_states"
                        [value]="item.id"
                        [disabled]="getselectedCheck(i, item.id, 'StateID')"
                      >
                        {{ item.state_name }}
                      </mat-option>
                    </mat-select>
                    <app-error-message
                      [type]="'group'"
                      [formName]="getFormName(i)"
                      [fieldName]="'StateID'"
                    >
                    </app-error-message>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>RX Packaging:</label>
                    <mat-select
                      class="form-control mat-select"
                      placeholder="Type"
                      formControlName="InventoryTypeID"
                      (selectionChange)="
                        onSelectionChange(
                          $event,
                          i,
                          PackagingType.RX,
                          'InventoryTypeID'
                        )
                      "
                    >
                      <mat-option
                        *ngFor="let item of inventryType.rx_inventory_types"
                        [value]="item.id"
                        [disabled]="
                          getselectedCheck(i, item.id, 'InventoryTypeID')
                        "
                      >
                        {{ item.type }}
                      </mat-option>
                    </mat-select>
                    <app-error-message
                      [type]="'group'"
                      [formName]="getFormName(i)"
                      [fieldName]="'InventoryTypeID'"
                    >
                    </app-error-message>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Quantity:</label>
                    <input
                      class="form-control"
                      type="number"
                      placeholder="Enter Quantity"
                      formControlName="Quantity"
                      (change)="
                        onSelectionChange(
                          $event,
                          i,
                          PackagingType.RX,
                          'Quantity'
                        )
                      "
                      (keyup)="
                        onSelectionChange(
                          $event,
                          i,
                          PackagingType.RX,
                          'Quantity'
                        )
                      "
                    />
                    <app-error-message
                      [type]="'group'"
                      [formName]="getFormName(i)"
                      [fieldName]="'Quantity'"
                    >
                    </app-error-message>
                  </div>
                </div>
                <div class="col-md pt-4 text-right">
                  <button mat-icon-button (click)="remove(i, item.value)">
                    <img
                      src="assets/images/random_assets/delete_field.png"
                      alt="delete_field icon"
                    />
                  </button>
                </div>
                <div class="col-md-4" *ngIf="i == 1">
                  <div class="form-group">
                    <mat-checkbox class="example-margin" [formControl]="isCopy"
                      >Same location for all
                    </mat-checkbox>
                  </div>
                </div>
                <ng-container>
                  <div
                    class="error-message text-danger ml-3"
                    *ngIf="rxQtyErrors.includes(i)"
                  >
                    Quantity does not exist, please try another
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

  <div class="row mt-4">
    <div class="col-md-12 d-flex align-items-end justify-content-end">
      <button class="custom-btn" (click)="this.dialogRef.close()">
        Cancel
      </button>
      <button class="custom-btn" type="submit" [disabled]="isDisabled">
        Save
        <span class="whiteLoader" *ngIf="isLoading"></span>
      </button>
    </div>
  </div>
</form>
